export default __webpack_public_path__ + "static/media/15.91019284.wav";